import { render, staticRenderFns } from "./DevWork.vue?vue&type=template&id=524712d6&"
import script from "./DevWork.vue?vue&type=script&lang=js&"
export * from "./DevWork.vue?vue&type=script&lang=js&"
import style0 from "./DevWork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports